module.exports = __webpack_public_path__ + "static/media/resize.86969377.JPG";